export default {
  'ROOM' (state) {
    return state.room
  },
  'ROOMS' (state) {
    return state.rooms
  }
}
